export default __webpack_public_path__ + "assets/images/80d618d1a4ff9b1f5a5c063c71988304.svg";